var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('course-imgs-temp',{attrs:{"img-urls":_vm.imgUrls}})}
var staticRenderFns = []

export { render, staticRenderFns }